import React, { CSSProperties, PropsWithChildren } from 'react';
import { Box } from '@mui/material';
import { Column } from '../types';

interface Props<Data extends Record<string, any>, Context extends any = any> {
  context: Context;
  column?: Column<Data, Context>;
  sx?: CSSProperties;
}

export const TableCell = <Data extends Record<string, any>, Context extends any = any>({
  sx = {},
  column,
  children,
}: PropsWithChildren<Props<Data, Context>>) => (
  <Box className="listing-cell" sx={{ minWidth: column?.width ?? '20rem' }} style={sx}>
    {children}
  </Box>
);
